

import icons from "url:../../img/icons.svg";
import View from "./view.js";


class Results extends View {
    _parentEl = document.querySelector('.results');
    _errorMessage = "No recipes were found for your query. Please try again!";
    _successMessage = "";


    _generateMarkup() {
        return this._data.reduce((str, recipe) => str + this._generateMarkupPreview(recipe), "");       
    }
    

    _generateMarkupPreview(recipe) {
        const urlID = window.location.hash.slice(1);
        const active = (urlID === recipe.id) ? "preview__link--active" : "";

        return `
            <li class="preview">
                <a class="preview__link ${active}" href="#${recipe.id}">
                <figure class="preview__fig">
                    <img src="${recipe.image}" alt="${recipe.title}" />
                </figure>
                <div class="preview__data">
                    <h4 class="preview__title">${recipe.title}</h4>
                    <p class="preview__publisher">${recipe.publisher}</p>
                    <div class="preview__user-generated ${!recipe.key ? "hidden" : "te"}">
                        <svg>
                            <use href="${icons}#icon-user"></use>
                        </svg>
                    </div>
                </div>
                </a>
            </li>`;
    }
}


export default new Results();